import React from 'react';
import './PaymentSuccessModal.scss';

function PaymentSuccessModal({onClose}) {
    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h2>Congratulations!</h2>
                <h3>Your payment was successful.</h3>
                <p>Thank you for your trust in our services.</p>
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
}

export default PaymentSuccessModal;
